const SITE_URL = process.env.VUE_APP_SITE_URL;

export const meishiPath = (): Function => {
  return (designNo?: number) => {
    if (typeof designNo !== "undefined") {
      return `${SITE_URL}/detail/${designNo}/${designNo}.gif`;
    } else {
      return `${SITE_URL}/common/image/form-ph002.gif`;
    }
  };
};

export const fontPath = (): Function => {
  return (font: string): string => {
    return `${process.env.BASE_URL}font/${font}.gif`;
  };
};

export const paperPath = (): Function => {
  return (paperNo: number): string => {
    return `${SITE_URL}/sheet/${paperNo}/${paperNo}-thumbnail.gif`;
  };
};

export const logoFilePath = (): Function => {
  return (logoFile: string): string => {
    return `${SITE_URL}/meishi/api-form/uploads/tmp/${logoFile}`;
  };
};
